import type { SVGProps } from 'react'
const LinePaintBrush = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="m16.75 15.311-.383.384a2.75 2.75 0 0 1-1.945.805h-2.868c-.331 0-.65.132-.884.366l-4.399 4.4a2.497 2.497 0 0 1-3.536 0 2.497 2.497 0 0 1 0-3.536l4.4-4.4a1.25 1.25 0 0 0 .366-.883V9.578c0-.729.29-1.428.805-1.944l.914-.914h.001l5.53-5.529 8.06 8.061-6.06 6.06v-.001Zm-7-7-.383.384A1.25 1.25 0 0 0 9 9.578v2.869a2.75 2.75 0 0 1-.806 1.944l-4.399 4.4a.997.997 0 0 0 0 1.414.997.997 0 0 0 1.414 0l4.4-4.4A2.75 2.75 0 0 1 11.554 15h2.868c.332 0 .65-.132.884-.366l.384-.384zm7.001 4.88-5.94-5.94 3.94-3.938 1.438 1.438-1.47 1.469 1.061 1.06 1.47-1.469 1.189 1.19-2.72 2.719 1.061 1.06 2.72-2.719 1.19 1.191z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LinePaintBrush }
